import PropTypes from "prop-types";
import React from "react";
import {
  Form,
  FormControl,
  FormGroup,
  FormLabel,
  FormText,
  Row,
  Col,
  Card,
} from "react-bootstrap";
import { useIntl } from "react-intl";

const message = {
  filter: {
    id: "modules.EmailEstablishment.components.Establishments.filter",
    description: "Filter label",
    defaultMessage: "Filter on name",
  },
  placeholder: {
    id: "modules.EmailEstablishment.components.Establishments.placeholder",
    description: "Placeholder filter label",
    defaultMessage: "Enter a name",
  },
  search: {
    id: "modules.EmailEstablishment.components.Establishments.search",
    description: "Search helper label",
    defaultMessage: "Search is not case sensitive",
  },
};

const SearchForm = ({ searchTitle, onSearchChange }) => {
  const intl = useIntl();

  return (
    <Card bg="light" className="mb-4">
      <Card.Body>
        <Form>
          <Row>
            <Col xs={12} md={8} lg={8}>
              <FormGroup controlId="searchFormTitle">
                <FormLabel>{intl.formatMessage(message.filter)}</FormLabel>
                <FormControl
                  type="text"
                  value={searchTitle}
                  placeholder={intl.formatMessage(message.placeholder)}
                  onChange={onSearchChange}
                  className="mb-2"
                />
                <FormText>{intl.formatMessage(message.search)}</FormText>
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};

SearchForm.propTypes = {
  searchTitle: PropTypes.string,
  onSearchChange: PropTypes.func.isRequired,
};

export default SearchForm;
